import { HeadlineWithOptionalCtaProps } from '@ahc-digital/component-library';
import { C03HeadlineWithOptionalCTAProps } from './C03HeadlineWithOptionalCTA.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { ReactNode } from 'react';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';

export function GetHeadlineWIthOptionalCTAModel(
  props?: C03HeadlineWithOptionalCTAProps
): HeadlineWithOptionalCtaProps {
  const { renderText } = useConditionalRendering();

  const { fields, params, rendering } = props || {};
  const { AnchorLinkTargetName, DynamicPlaceholderId, HeadlineTag } = params || {};

  const phKey = `headline-cta-${DynamicPlaceholderId}`;
  const placeholder: ReactNode = rendering ? (
    <Placeholder name={phKey} rendering={rendering} />
  ) : (
    <></>
  );

  return {
    className: translationClasses(params),
    id: AnchorLinkTargetName,
    cta: placeholder,
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink(HeadlineTag, 'h1'),
    shouldDisplayGoldBar: getCheckbox(params?.ShouldDisplayGoldBar),
    goldBarAlignment: getDroplink(params?.GoldBarAlignment, 'left'),
  };
}
